import { type z } from 'zod';

import { CreateMediaResourceSchema } from './create-media-resource.dto';

export const UpdateMediaResourceSchema = CreateMediaResourceSchema.partial();

export type IUpdateMediaResourceDto = z.infer<typeof UpdateMediaResourceSchema>;
